import { fetchIfLoggedIn } from '../utils.js'
import * as actions from 'actions'

export const registerUserWebAuthN = factor => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.START_USER_WEBAUTHN_REGISTER,
      method: 'post',
      path: `/mfa/register/${factor}`,
      postBody: {
        action: 'START_REGISTER',
      },
    })
  )
}

export const finishRegisterUserWebAuthN = (
  factor,
  creationOptionsId,
  publicKeyCredential,
  webAuthnName,
  webAuthnDescription
) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.FINISH_USER_WEBAUTHN_REGISTER,
      method: 'post',
      path: `/mfa/register/${factor}`,
      postBody: {
        action: 'FINISH_REGISTER',
        creationOptionsId,
        friendlyName: webAuthnName,
        description: webAuthnDescription,
        publicKeyCredentialJson: JSON.stringify(publicKeyCredential),
      },
    })
  )
}

export const getRegisteredUserMFAsForAdmin = userID => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.GET_USER_MFA_REGISTERATIONS_FOR_ADMIN,
      method: 'get',
      path: `/mfa/admin/registrations/users/${userID}`,
    })
  )
}

export const deleteUserMFADevice = (factor, userID, credentials) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.DELETE_USER_MFA_DEVICE,
      method: 'delete',
      path: `/mfa/admin/registrations/${factor}/users/${userID}/credentials/${credentials}`,
    })
  )
}

export const deleteAllUserMFADevice = userID => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.DELETE_ALL_USER_MFA_DEVICE,
      method: 'delete',
      path: `/mfa/admin/registrations/users/${userID}`,
    })
  )
}

export const initiateWebAuthnAuthentication = () => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.INITIATE_WEB_AUTHN_AUTHENTICATION,
      method: 'post',
      path: `/step-up/authenticate/WEB_AUTHN`,
      postBody: {
        action: 'START_AUTHN',
      },
    })
  )
}
